module.exports = __webpack_public_path__ + "assets/476b20e128dc67eef9ce37b7c1c6be67.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/drop/0/WildStop2.mp3
 ** module id = 243
 ** module chunks = 0
 **/